<section class="container-flex internal-page-margins device-setup">
  <div class="container-flex-row margin-bottom-20">
    <h1 class="header">Let’s set up your phone and get you started!</h1>
    <div class="subhead compatability">
      <h2 class="subtitle">Let’s find out if your phone is compatible with FreeUp Mobile:</h2>
      <p class="help-text">This will ensure we provide the correct data settings information for your device</p>
      <form #formCtrl="ngForm" class="compatibility-form">
        <div class="compatability-card">
          <fieldset>
            <label class="label" for="phoneNumber">Enter your FreeUp phone number:</label>
            <input type="tel" required [(ngModel)]="mdn" id="phoneNumber" #phoneNumber="ngModel" name="phoneNumber"
              restrictNumbers minlength="10" maxlength="10" [pattern]="phonePattern">
            <label class='validation-message' *ngIf="phoneNumber.touched && !mdn" id="required-mdn-msg">
              This field is required.
            </label>
            <label class='validation-message' *ngIf="phoneNumber.hasError('pattern') && phoneNumber.dirty"
              id="invalid-mdn-msg">
              The field should be filled out with a valid FreeUp number.
            </label>
            <label class='validation-message'
              *ngIf="(phoneNumber.hasError('minlength') && phoneNumber.dirty && !phoneNumber.hasError('pattern') && phoneNumber.touched)"
              id="invalid-minlength-mdn-msg">
              Phone number must be 10 digits
            </label>
          </fieldset>
        </div>
        <div class="twelve actions-container no-padding">
          <div class="form-actions">
            <button type="button" class="button primary" (click)="os='android';checkPhoneCompatibility()"
              id="android-button">Android</button>
            <button type="button" class="button secondary" (click)="os='ios';isIos=true;checkPhoneCompatibility()"
              id="ios-button">iPhone</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</section>
<!-- <section *ngIf="!userPlan && compatibilityChecked">
  <app-ios-gsm (backToMain)="reset(event)" *ngIf="os == 'ios' && !!isAtt"></app-ios-gsm>
  <app-android-gsm (backToMain)="reset(event)" *ngIf="os == 'android' && !!isAtt"></app-android-gsm>
  <app-t-mobile [isIos]="isIos" *ngIf="!!isTmo"></app-t-mobile>
</section> -->